import { CircularProgress } from '@mui/material'
import React from 'react'

function NotFound404() {
  return (
    <div className="container">
            <div className='row mt-5'>
                <div className='col-md-12 text-center'>
                    <img src='/images/ghelp-logo.png' style={{width:"30%"}} />
                </div>
                <div className="col-md-12 text-center mt-5">
                    <CircularProgress></CircularProgress>
                </div>
                <div className="col-md-12 text-center">
                    <p>No Portal Selected, Please Scan QR Code </p>
                </div>
            </div>
        </div>
  )
}

export default NotFound404